module.exports = __webpack_public_path__ + "static/media/Chewy-Regular.53ee0977.ttf";